module.exports = {
      id: "zoom-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#zoom-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__fus078/icons/zoom.svg
// module id = /opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/zoom.svg
// module chunks = site__fus078